import { jsx as _jsx } from "react/jsx-runtime";
import { observer } from 'mobx-react';
import * as React from 'react';
import { Button, Icon } from '@marvelapp/ballpark-components';
import { PAUSE_ICON } from '@marvelapp/ballpark-theme';
export default observer(function PauseButton({ onClick, }) {
    return (_jsx(Button, { "data-testid": "pause-user-test", kind: "ghost", onClick: onClick, size: "s", children: _jsx(Icon, { display: "block", paths: PAUSE_ICON }) }));
});
